import { render } from "./SampleSection.vue?vue&type=template&id=bd919f3e"
import script from "./SampleSection.vue?vue&type=script&lang=js"
export * from "./SampleSection.vue?vue&type=script&lang=js"

import "./SampleSection.vue?vue&type=style&index=0&id=bd919f3e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__